import { type ApiResponse, FmsApi } from "../fmsapi"
import BaseController from "./base"

export class SeminarController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "seminar")
  }

  public async findMyTickets(fairId : number) : Promise<ApiResponse> {
    return await this.callApi("myTickets", {
        fairId : fairId
    })
  }
}
